import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import NavbarTop from 'componentes/navbar/top/NavbarTop.js';
import NavbarVertical from 'componentes/navbar/vertical/NavbarVertical.js';
import Footer from 'componentes/footer/Footer.js';
import { useAppContext } from 'context/AppProvider.js';
import { useAuth } from 'context/AuthProvider.js';

const MainLayout = () => {
  const Auth = useAuth();
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes('kanban');
  let history = useNavigate();
  useEffect(() => {
    var authCheck = Auth.getSessionData();
    console.log(authCheck);
    if (!authCheck || authCheck?.length === 0 || authCheck === 'null') {
      history('/security/logout');
      return;
      //Router.push('/login');
    }
  }, []);
  // const isChat = pathname.includes('chat');

  const {
    config: { isFluid, navbarPosition }
  } = useAppContext();

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={isFluid ? 'container-fluid' : 'container'}>
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
        <NavbarVertical />
      )}
      <div className={classNames('content', { 'pb-0': isKanban })}>
        <NavbarTop />
        {/*------ Main Routes ------*/}
        <Outlet />
        {!isKanban && <Footer />}
      </div>
    </div>
  );
};

export default MainLayout;
